import { logger } from 'lib/logger';
import { sharingOnboardingTariffs } from 'reactApp/appHelpers/featuresHelpers/features/sharingOnboarding';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { loadPaidInfoRequest, loadPaidInfoSuccess } from 'reactApp/modules/paidInfo/paidInfo.module';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { type SnackbarItem, SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { setIsLoading } from 'reactApp/modules/user/user.actions';
import { type RootState, store as reduxStore } from 'reactApp/store';
import { captureException } from 'reactApp/utils/tracer';
import { call, cancel, put, select, take, takeEvery } from 'redux-saga/effects';

import { SharedModalActions } from './sharedModal.module';

const snackbarErrorItem: SnackbarItem = {
    type: SnackbarTypes.failure,
    id: 'sharing_onboarding',
    text: 'Не удалось подобрать тариф',
    closable: true,
};

export function* handleBuyOnboardingSubscription() {
    try {
        const isMobile = EnvironmentSelectors.isMobile();

        yield call(productsController.loadProducts);

        yield put(loadPaidInfoRequest());
        const { isLoaded } = yield select(PaidInfoSelectors.getLoadingState);
        if (!isLoaded) {
            yield take(loadPaidInfoSuccess);
        }

        const userWithoutPayment = yield select(PaidInfoSelectors.isUserWithoutPayment);

        const trial = yield select((state: RootState) => ProductsSelectors.getProductById(state, sharingOnboardingTariffs.trial));
        const forceTrial = yield select((state: RootState) => ProductsSelectors.getProductById(state, sharingOnboardingTariffs.forceTrial));
        const defaultProduct = yield select((state: RootState) =>
            ProductsSelectors.getProductById(state, sharingOnboardingTariffs.default)
        );

        const paidLessThan3Month = yield select((state: RootState) => PaidInfoSelectors.lastPaymentWasLessThan(state, { months: 3 }));

        const product = userWithoutPayment ? trial : paidLessThan3Month ? defaultProduct : forceTrial;

        if (!product) {
            yield put(showSnackbarAction(snackbarErrorItem));
            yield cancel();
        }

        const paySource = 'advanced_settings';
        yield put(
            openTariffBuy({
                productId: product.id,
                paySource,
                isMobile,
                hideOtherTariffs: product === trial || product === forceTrial,
                onSuccess: () => {
                    reduxStore.dispatch(setIsLoading({ value: true }));
                },
            })
        );
    } catch (error) {
        yield put(showSnackbarAction(snackbarErrorItem));
        captureException(error, { issueKey: 'sharingOnboarding/buy_error' });
        logger.error(error);
    }
}

export function* watchSharedModal() {
    yield takeEvery(SharedModalActions.buyOnboardingSubscription.toString(), handleBuyOnboardingSubscription);
}
